<template>
    <div>
      <div v-if="debug_show_page_name==true" style="color:green;">page_0041_master_system_detail</div>
        <app-header>esma</app-header>
        <div :class="'container ' + pageContainerSize">
          <title-and-slot title="メールメッセージ詳細" >
            <div>
            </div>
          </title-and-slot>
          <div class="row" style="margin-bottom:10px;">
            <div class="col-xs-12" style="">
                <label for="subject">件名</label>
                <input 
                  type="text" 
                  class="form-control"
                  v-model="mailSubject"
                  name="subject" 
                  id="subject">
            </div>
            <div class="col-xs-12" style="">
              <label for="content">本文</label>
              <textarea 
                class="form-control"
                name="content"
                id="content"
                cols="30"
                rows="10"
                v-model="mailContent"
              ></textarea>
            </div>
            <div class="col-xs-12" style="margin:20px 0px;">
              <master-user
              @email_list_updated="emailListUpdated"
              :searchData="selectedUserIDs"
              @selected="onSelectedUserSelected"
              :showSearch="false"
              :showDetailsButtons="false"
              :allUserIds="false"
              refreshTag="selectedUsersRefresh"
              :showCheckBox="true"
              subSearchMode="only"
              tabStyle="width: 100%; height: 200px"
              />
            </div>
          </div>
          <div class="col-xs-12" style="">
          <div class="row" style="margin-bottom:10px;" >
              <button class="btn btn-primary" style="min-width:100px;float: left;margin-left: -10px;" @click="backToList" >＜　戻る</button>
              <button class="btn btn-info" style="min-width:100px;float:right;margin-left: 10px;margin-right:5px;" @click="addUsers">ユーザ追加</button>
              <button class="btn btn-success" style="min-width:100px;float:right;margin-left: 10px;margin-right:5px;" @click="removeUsers" >ユーザ選択解除</button>
              <button class="btn btn-info" style="min-width:100px;float:right;margin-left: 10px;margin-right:5px;" @click="prepareSendMail">メール作成</button>
              <a
                ref="send_mail_link"
                target="new_email"
                style="display:none;"
                >mailto</a>
          </div>
          </div>
      </div>
      <!-- <confirmation-modal tag="deleteMailMessageCreateModal" /> -->
    </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import { fields, filed_types } from '@/rules/fields_mail_message';
import { utils } from '@/libs/utils';
import _debug from 'debug';
var mdebug = _debug('esma:mail_message');
import fieldBoxes from '@/components/form-field';
import masterUser from '@/components/sub_pages/master_user';
import acl from '@/rules/acl_rules';
import mixinPageCommon from '@/mixins/mixin_page_common';
import mixinDatasource from '@/mixins/mixin_datasource';
import { bus } from '@/libs/bus';
import Master_user from '../components/sub_pages/master_user.vue';
export default {
  mixins: [mixinPageCommon,mixinDatasource],
    components: {
    'field-box': fieldBoxes,
    'master-user':masterUser
  },
  data() {
    return {
      api_name:"mail_message",
      page_acl: acl.master,
      loading:true,
      selected_user_ids:[],
      local_selected_user_selected:[],
      mail_content:"",
      mail_subject:"",
      email_list:""
    };
  },
  computed: {
    mailContent:{
      get(){
        return this.mail_content;
      },
      set(v){
        this.mail_content = v;
      }
    },
    mailSubject:{
      get(){
        return this.mail_subject;
      },
      set(v){
        this.mail_subject = v;
      }
    },
    selectedUserIDs:{
      get(){
        return this.selected_user_ids;
      },
      set(v){
        if(Array.isArray(v) == false || v.length == 0){
          v = [-1]
        }
        this.selected_user_ids = v;
      }
    },
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
  },
  methods: {
    emailListUpdated(list){
      this.email_list = list;
    },
    prepareSendMail(){

      //href='mailto:?bcc=yamashita@iss-j.com&subject=日本語のいくつかの主題&body=日本語の長いテキスト。%0D%0Aいくつかの行で。%0D%0Aまた、テキストを追加することもできます。'

      var mail_buff = "mailto:?bcc=" + (this.email_list || " ")
      mail_buff += "&subject=" +encodeURIComponent(this.mailSubject.replace(/\n/g,"").replace(/\r/g,""))
      mail_buff += "&body=" + encodeURIComponent(this.mailContent) //.replace(/\r\n/g,"%0D%0A").replace(/\n\r/g,"%0D%0A").replace(/\n/g,"%0D%0A").replace(/\r/g,"%0D%0A")

      var send_mail_link = this.$refs.send_mail_link;
      send_mail_link.href = mail_buff
      send_mail_link.click();
    },
    removeUsers(){
      var temp = this.selectedUserIDs || [-1];
      var temp2 = _.remove(temp,(r=>{ return this.local_selected_user_selected.indexOf(r) < 0}))
      this.selectedUserIDs = temp2;
      if(this.selectedUserIDs.length == 0){
        this.selectedUserIDs = [-1]
      }
      window.sessionStorage.setItem("send_mail_destination",JSON.stringify(this.selectedUserIDs))
      bus.$emit("selectedUsersRefresh",this.selectedUserIDs)
    },
     onSelectedUserSelected(list){
      this.local_selected_user_selected = list;
    },
    addUsers(){
      return this.$router.push({ name: "page_0081_mail_message_users", params: {seq_id:this.$route.params.seq_id}  });
    },
    backToList(){
      return this.$router.push({ name: "page_0081_mail_message_detail", params: {seq_id:this.$route.params.seq_id}  });
    }
  },
  mounted() {
  },
  beforeDestroy() {
  },
  beforeMount() {
    this.mailContent = window.sessionStorage.getItem("send_mail_message")
    this.mailSubject = window.sessionStorage.getItem("send_mail_subject")
    var temp = window.sessionStorage.getItem("send_mail_destination");
    if(temp && temp.length > 1){
      temp = JSON.parse(temp)
    }
    this.selected_user_ids = temp ||[-1];
  }
};

</script>
<style scoped>

input:focus::-webkit-input-placeholder {
  color: transparent;
}
</style>


// WEBPACK FOOTER //
// page_0081_mail_message_create.vue?2fc8451e